import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_SAMPLE_CONTAINER_TEST_MAP_DETAIL,
    getSampleContainerTestMapDetailFail,
    getSampleContainerTestMapDetailSuccess
} from '../action/getSampleContainerTestMapDetailAction'

// api 
import getSampleContainerTestMapDetailApi from '../api/getSampleContainerTestMapDetailApi'

export function* getSampleContainerTestMapDetailSaga(action) {
    try {
        const response = yield call(() => getSampleContainerTestMapDetailApi(action.params))
        if (response.data.status === 1) {
            yield put(getSampleContainerTestMapDetailSuccess(response, action))
        } else {
            yield put(getSampleContainerTestMapDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(getSampleContainerTestMapDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_SAMPLE_CONTAINER_TEST_MAP_DETAIL, getSampleContainerTestMapDetailSaga)
}